import { defineStore } from 'pinia'
import { ROLES_CODES } from './../constants/roles'
import { TOURS_CODES } from './../constants'

interface State {
  isAuth: boolean
  roleCode: ROLES_CODES | null
  tours: TOURS_CODES[]
  activeTourId: TOURS_CODES | undefined
}

const useAuthStore = defineStore('auth', {
  state: (): State => ({
    isAuth: false,
    roleCode: null,
    tours: [],
    activeTourId: undefined,
  }),
  getters: {
    isGuest: ({ roleCode }) => roleCode === ROLES_CODES.GUEST,
    isPartner: ({ roleCode }) => roleCode === ROLES_CODES.PARTNER,
    isPartnerManager: ({ roleCode }) => roleCode === ROLES_CODES.PARTNER_MANAGER,
    isSuperAdmin: ({ roleCode }) => roleCode === ROLES_CODES.SUPER_ADMIN,
    isCEO: ({ roleCode }) => roleCode === ROLES_CODES.CEO,
    getTours: state => () => state.tours,
    getActiveTourId: state => state.activeTourId,
  },
  actions: {
    setIsAuth(value: boolean) {
      this.isAuth = value
    },
    setRole(roleCode: ROLES_CODES) {
      this.roleCode = roleCode
    },
    clearRole() {
      this.roleCode = null
    },
    setUserTours(toursList: TOURS_CODES[]) {
      this.tours = toursList
    },
    getIsTourActive(id: TOURS_CODES) {
      return this.activeTourId === id
    },
    setActiveTourId(id: TOURS_CODES) {
      this.activeTourId = id
    },
    cleanActiveTourId() {
      this.activeTourId = undefined
    },
  },
})

export default useAuthStore
